import { Inject } from '@angular/core';
import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { NavigationService } from '../services/navigation-service.service';

export const cvvResolver: ResolveFn<boolean> = (route, state) => {
const navigationService = inject(NavigationService); // Injecting the service
  const id = route.paramMap.get('id');

  if (id) {
    navigationService.navigateWithIdToCvv(id)
    return of(true); // Resolve with 'true', meaning the route can activate
  } else {
    return of(false); // Prevent navigation
  }
}



